import {isNullOrUndefined} from "util";

export class StringUtils {

    static isBlank = (str:string) => {
        return str.trim().length === 0;
    };

    static contains = (parentStr:string, childStr:string, ignoreCase?:boolean) => {
        if (ignoreCase) {
            parentStr = parentStr.toLowerCase();
            childStr = childStr.toLowerCase();
        }
        return parentStr.indexOf(childStr) > -1;
    };

    public static getStringToSetStrongTag(item, name): string {
        let positions = [];
        let searchWordsKeys = Object.keys(item.metadata);
        searchWordsKeys.forEach(key => {
            if (!!item.metadata[key][name]) {
                item.metadata[key][name].position.forEach(pos =>
                    positions.push(pos)
                );
            }
        });
        return this.addStrongTag(item[name], this.intersect(positions));
    }

    private static addStrongTag(source, positions): string {
        let startTag = '<b>';
        let endTag = '</b>';

        for (let i = 0, offset = 0; i < positions.length; i++, offset += 7) {
            let start = positions[i];
            source = source.slice(0, start[0] + offset) + startTag + source.slice(start[0] + offset, start[1] + offset) + endTag + source.slice(start[1] + offset, source.length)
        }
        return source;
    }

    public static intersect(positions: any[]): any[] {
        let highlightPositions = [];
        if (positions.length == 0) {
            return highlightPositions;
        }

        if (positions.length == 1) {
            highlightPositions.push([positions[0][0], positions[0][0] + positions[0][1]]);
            return highlightPositions;
        }
        positions.sort((a, b) => {
            return a[0] < b[0] ? -1 : 1;
        });
        let startIndex = positions[0][0],
            endIndex = positions[0][0] + positions[0][1];
        for (let current = 0, next = 1; current < positions.length; current++, next++) {
            if (next < positions.length && endIndex > positions[next][0]) {
                let nextEndIndex = positions[next][0] + positions[next][1];
                endIndex = nextEndIndex > endIndex ? nextEndIndex : endIndex;
                continue;
            }
            highlightPositions.push([startIndex, endIndex]);
            if (next < positions.length) {
                startIndex = positions[next][0];
                endIndex = positions[next][0] + positions[next][1];
            }
        }
        return highlightPositions;
    }

    static equalsIgnoreCase(str1: string,str2: string): boolean {
        return !isNullOrUndefined(str1)
            && !isNullOrUndefined(str1)
            &&  str1.toLocaleLowerCase().localeCompare(str2.toLocaleLowerCase()) == 0;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/string.utils.ts